import React from 'react';

// Error Boundary specifically for Leaflet map component
// Catches errors and provides recovery for Leaflet-specific unmount issues
class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('MapErrorBoundary caught:', error.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center h-full bg-gray-900/90 text-white">
          <div className="text-center">
            <p className="text-lg mb-2">Map view interrupted</p>
            <p className="text-sm text-gray-400 mb-4">Navigate back to continue</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default MapErrorBoundary;
